if ($cookies.get("lang") == null) {

  $cookies.set("lang", "CN", "1y", "/")
}

global.LOCAL_STRING = {
  "base-header": {
    "首页": {
      "EN": "Home",
      "CN": "首页",
    },
    "关于长帝": {
      "EN": "About Westa",
      "CN": "关于长帝",
    },
    "产品中心": {
      "EN": "Products Center",
      "CN": "产品中心",
    },
    "品牌活动": {
      "EN": "News Center",
      "CN": "品牌活动",
    },
  },
  "base-footer": {
    "关于长帝": {
      "EN": "About Westa",
      "CN": "关于长帝",
    },
    "品牌介绍": {
      "EN": "Brand Introduction",
      "CN": "品牌介绍",
    },
    "发展历程": {
      "EN": "	Development",
      "CN": "发展历程",
    },
    "企业文化": {
      "EN": "Corporate Culture",
      "CN": "企业文化",
    },
    "荣誉奖项": {
      "EN": "Honorary Award",
      "CN": "荣誉奖项",
    },
    "产品中心": {
      "EN": "Products Center",
      "CN": "产品中心",
    },
    "品牌活动": {
      "EN": "News Center",
      "CN": "品牌活动",
    },
    "企业新闻": {
      "EN": "Corporate News",
      "CN": "企业新闻",
    },
    "全国统一服务热线": {
      "EN": "National Service Hotline",
      "CN": "全国统一服务热线",
    },
    "乐焙小程序": {
      "EN": "Lebei Mini Program",
      "CN": "乐焙小程序",
    },
    "官方微信": {
      "EN": "Official Wechat",
      "CN": "官方微信",
    },
    "官方微博": {
      "EN": "Official Weibo",
      "CN": "官方微博",
    },
  },
  "product_detail": {
    "产品参数": {
      "EN": "Product Parameters",
      "CN": "产品参数",
    },
    "同类推荐": {
      "EN": "Similar Recommendations",
      "CN": "同类推荐",
    },
  },
  "about": {
    "公司简介": {
      "EN": "Company Profile",
      "CN": "公司简介",
    },
  },

  "index": {
    "My Orders": {
      "EN": "My Orders",
      "CN": "我的订单",
    },
    "Address Book": {
      "EN": "Address Book",
      "CN": "地址簿",
    },
    "Tracking": {
      "EN": "Tracking",
      "CN": "订单追踪",
    },
    "Workbench": {
      "EN": "Workbench",
      "CN": "工作台",
    },
    "Service Content": {
      "EN": "Service Content",
      "CN": "服务简介",
    },
    "Custom Service": {
      "EN": "Custom Service",
      "CN": "联系客服",
    },
    "Logout": {
      "EN": "Logout",
      "CN": "注 销",
    }
  },



};
